import { render } from "./GetAllBookAPI.vue?vue&type=template&id=6d420cdb"
import script from "./GetAllBookAPI.vue?vue&type=script&lang=js"
export * from "./GetAllBookAPI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__